document.addEventListener("DOMContentLoaded", () => {
  const mq = window.matchMedia("(min-width: 992px)");
  let isDesktop = mq.matches;
  let resizeTimeout;

  function handleViewportChange(e) {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const nowDesktop = e.matches;

      // Só recarrega se mudou de estado (mobile ↔ desktop)
      if (nowDesktop !== isDesktop) {
        location.reload();
      }

      isDesktop = nowDesktop;
    }, 300); // ⏱️ debounce de 300ms
  }

  if (typeof mq.addEventListener === "function") {
    mq.addEventListener("change", handleViewportChange);
  } else {
    mq.addListener(handleViewportChange); // Safari mais antigo
  }

  // Efeito de fade-in para a barra inferior Prod
  const targetContainer = document.querySelector('#customProductWrapper');
  const observer = new IntersectionObserver((entries) => {
    const bottomBar = document.querySelector('#customBottomBarProd');
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        bottomBar.style.opacity = '1';
        bottomBar.style.pointerEvents = 'auto';
      } else {
        bottomBar.style.opacity = '0';
        bottomBar.style.pointerEvents = 'none';
      }
    });
  });

  if (targetContainer) {
    observer.observe(targetContainer);
  }

  // Barra de navegação
  // let lastScrollTop = 0;
  // const navbar = document.querySelector(".navbar__header .bottom");

  // window.addEventListener("scroll", function () {
  //   const currentScroll =
  //     window.pageYOffset || document.documentElement.scrollTop;

  //   if (currentScroll > lastScrollTop && currentScroll > 82) {
  //     navbar.style.top = "-50%";
  //   } else {
  //     navbar.style.top = "100%";
  //   }

  //   lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  // });

  const menuItems = document.querySelectorAll(".navbar__header .menu__item");

  menuItems.forEach((item) => {
    const dropdown = item.querySelector(".menu__sublinks");
    if (!dropdown) return;

    if (window.innerWidth > 992) {
      item.addEventListener("mouseenter", () => {
        const rect = dropdown.getBoundingClientRect();

        if (rect.right > window.innerWidth) {
          dropdown.style.left = "auto";
          dropdown.style.right = "0";
        } else {
          dropdown.style.right = "auto";
          dropdown.style.left = "0";
        }

        item.classList.add("active");
      });

      item.addEventListener("mouseleave", () => {
        item.classList.remove("active");
      });
    }

    if (window.innerWidth < 992) {
      item.addEventListener("click", (e) => {
        if (e.target.closest(".menu__sublinks a")) return;
        e.preventDefault();

        menuItems.forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.classList.remove("active");
          }
        });

        item.classList.toggle("active");
      });
    }
  });

  // Menu mobile
  const menu = document.querySelector(".navbar__header .menu-mobile");
  const wrapper = document.querySelector(".navbar__header .wrapper-mobile");
  const body = document.querySelector("body");
  const btnToggle = document.querySelector(
    ".navbar__header .navbar__mobile .mobile"
  );
  const btnClose = document.querySelector(".navbar__header .close-btn");
  const links = document.querySelectorAll(".navbar__header .menu-mobile a");

  // Abrir/fechar menu
  function toggleMenuMobile() {
    menu.classList.toggle("active");
    wrapper.classList.toggle("active");
    body.classList.toggle("active");
  }

  // Fechar menu
  function closeMenuMobile() {
    menu.classList.remove("active");
    wrapper.classList.remove("active");
    body.classList.remove("active");
  }

  // Abrir com botão de menu
  btnToggle?.addEventListener("click", function (event) {
    event.stopPropagation();
    toggleMenuMobile();
  });

  // Fechar com botão X
  btnClose?.addEventListener("click", function (event) {
    event.stopPropagation();
    closeMenuMobile();
  });

  // Fechar ao clicar fora do menu
  menu?.addEventListener("click", function (event) {
    if (!wrapper.contains(event.target)) {
      closeMenuMobile();
    }
  });

  // Fechar ao clicar em qualquer link
  links.forEach((link) => {
    link.addEventListener("click", () => {
      closeMenuMobile();
    });
  });

  // Variantes dos cards
  // const variantsCard = document.querySelectorAll(
  //   ".delucca__product-card .swiper"
  // );

  // variantsCard.forEach((wrapper) => {
  //   new Swiper(wrapper, {
  //     slidesPerView: "auto",
  //     spaceBetween: 8,
  //     freeMode: true,
  //     grabCursor: true,
  //   });
  // });
});
(function () {
  "use strict";

  /**
   * Inicializa os Swipers de variantes dentro de um contexto
   * @param {HTMLElement|Document} context
   */
  function initVariantSwipers(context) {
    context = context || document;

    const swipers = context.querySelectorAll(
      ".delucca__product-card .swiper:not(.swiper-initialized)"
    );

    if (!swipers.length) return;

    swipers.forEach((wrapper) => {
      new Swiper(wrapper, {
        slidesPerView: "auto",
        spaceBetween: 8,
        freeMode: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
      });
    });
  }

  function initQuickbuyModal() {
    if (document.documentElement.dataset.deluccaQuickbuyBound === "true") return;

    const modal = document.getElementById("delucca-quickbuy-modal");
    if (!modal) return;

    const content = modal.querySelector("[data-quickbuy-modal-content]");
    const closeButton = modal.querySelector("[data-quickbuy-close]");

    if (!content) return;

    document.documentElement.dataset.deluccaQuickbuyBound = "true";

    let swiperMain = null;
    let swiperThumbs = null;
    let activeQuickbuyProductId = null;

    const destroyGallery = () => {
      if (swiperMain && typeof swiperMain.destroy === "function") {
        swiperMain.destroy(true, true);
      }
      if (swiperThumbs && typeof swiperThumbs.destroy === "function") {
        swiperThumbs.destroy(true, true);
      }
      swiperMain = null;
      swiperThumbs = null;
    };

    const closeModal = () => {
      if (!modal.open) return;
      modal.close();
      destroyGallery();
      activeQuickbuyProductId = null;
      content.innerHTML = "";
    };

    const updatePriceAndAvailability = (scope) => {
      const optionSelects = Array.from(scope.querySelectorAll("[data-quickbuy-option-select]"));
      const optionInputs = Array.from(scope.querySelectorAll("[data-quickbuy-option-input]"));
      const variantsScript = scope.querySelector("[data-quickbuy-variants]");
      const variantsInline = scope.dataset.quickbuyVariants || "";
      const variantIdInput = scope.querySelector("[data-quickbuy-variant-id]");
      const compareEl = scope.querySelector("[data-quickbuy-compare]");
      const currentEl = scope.querySelector("[data-quickbuy-current]");
      const installmentsEl = scope.querySelector("[data-quickbuy-installments]");
      const atcButton = scope.querySelector('add-to-cart-component [ref="addToCartButton"]');
      const quantityInput = scope.querySelector('quantity-selector-component input[name="quantity"]');
      const quantityButtons = scope.querySelectorAll("quantity-selector-component button");

      if (!atcButton) return;

      let variants = [];
      if (variantsScript?.textContent) {
        try {
          variants = JSON.parse(variantsScript.textContent);
        } catch (error) {
          console.error(error);
        }
      }

      if (!variants.length && variantsInline) {
        try {
          variants = JSON.parse(variantsInline);
        } catch (error) {
          console.error(error);
        }
      }

      if (!variants.length) {
        if (variantIdInput?.value) {
          atcButton.disabled = false;
          if (quantityInput) {
            quantityInput.disabled = false;
          }
          quantityButtons.forEach((button) => {
            button.disabled = false;
          });
        }
        return;
      }

      const formatMoney = (cents) => {
        const value = Number(cents || 0) / 100;
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(value);
      };

      const selectedValues = [];

      if (optionInputs.length) {
        const groupedByOption = optionInputs.reduce((grouped, input) => {
          const optionIndex = Number.parseInt(input.dataset.optionIndex || "", 10);
          if (Number.isNaN(optionIndex)) return grouped;
          if (!grouped[optionIndex]) grouped[optionIndex] = [];
          grouped[optionIndex].push(input);
          return grouped;
        }, []);

        groupedByOption.forEach((inputs, optionIndex) => {
          if (!Array.isArray(inputs) || !inputs.length) return;
          const checkedInput = inputs.find((input) => input.checked) || inputs[0];
          selectedValues[optionIndex] = checkedInput?.value || "";

          inputs.forEach((input) => {
            const label = input.closest("label");
            if (!label) return;
            if (input.checked) {
              label.classList.add("is-active");
            } else {
              label.classList.remove("is-active");
            }
          });
        });
      } else {
        optionSelects.forEach((select, optionIndex) => {
          selectedValues[optionIndex] = select.value;
        });
      }

      const selectedLabels = Array.from(scope.querySelectorAll("[data-quickbuy-option-selected]"));
      if (selectedLabels.length) {
        selectedLabels.forEach((label) => {
          const optionIndex = Number.parseInt(label.dataset.optionIndex || "", 10);
          if (Number.isNaN(optionIndex)) return;
          const value = selectedValues[optionIndex];
          if (value) {
            label.textContent = `(${value})`;
            label.hidden = false;
          } else {
            label.textContent = "";
            label.hidden = true;
          }
        });
      }

      let selectedVariant = null;

      if (variants.length) {
        if (selectedValues.length) {
          selectedVariant = variants.find((variant) => {
            if (!Array.isArray(variant.options)) return false;
            return selectedValues.every((value, index) => variant.options[index] === value);
          });
        } else if (variantIdInput?.value) {
          selectedVariant = variants.find((variant) => String(variant.id) === String(variantIdInput.value));
        }

        if (!selectedVariant) {
          selectedVariant = variants[0];
        }
      }

      const variantId = selectedVariant?.id ? String(selectedVariant.id) : "";
      const isAvailable = Boolean(selectedVariant?.available);
      const variantPrice = Number(selectedVariant?.price || 0);
      const variantComparePrice = Number(selectedVariant?.compare_at_price || 0);

      const syncGalleryByVariant = () => {
        if (!selectedVariant || !swiperMain) return;

        const slides = Array.from(scope.querySelectorAll(".swipper-container .swiper-slide"));
        if (!slides.length) return;

        const mediaIdCandidates = [
          selectedVariant?.featured_media?.id,
          selectedVariant?.featured_image?.id,
          selectedVariant?.image_id,
        ]
          .filter(Boolean)
          .map((id) => String(id));

        let targetIndex = -1;

        if (mediaIdCandidates.length) {
          targetIndex = slides.findIndex((slide) => mediaIdCandidates.includes(String(slide.dataset.mediaId || "")));
        }

        if (targetIndex === -1 && selectedVariant?.featured_image?.src) {
          const normalize = (url) => String(url || "").replace(/^https?:/, "").split("?")[0];
          const targetSrc = normalize(selectedVariant.featured_image.src);

          targetIndex = slides.findIndex((slide) => {
            const image = slide.querySelector("img");
            const slideSrc = normalize(image?.getAttribute("src") || image?.getAttribute("data-src") || "");
            return slideSrc && targetSrc && (slideSrc.includes(targetSrc) || targetSrc.includes(slideSrc));
          });
        }

        if (targetIndex > -1) {
          swiperMain.slideTo(targetIndex, 250);

          if (swiperThumbs) {
            swiperThumbs.slideTo(targetIndex, 250);
          }
        }
      };

      syncGalleryByVariant();

      if (currentEl) {
        currentEl.textContent = formatMoney(variantPrice);
      }

      if (compareEl) {
        if (variantComparePrice > variantPrice) {
          compareEl.textContent = formatMoney(variantComparePrice);
          compareEl.classList.remove("hidden");
        } else {
          compareEl.textContent = "";
          compareEl.classList.add("hidden");
        }
      }

      if (installmentsEl) {
        let installmentsCount = 0;

        if (variantPrice > 20999) {
          installmentsCount = 6;
        } else if (variantPrice > 17499) {
          installmentsCount = 5;
        } else if (variantPrice > 13999) {
          installmentsCount = 4;
        } else if (variantPrice > 10499) {
          installmentsCount = 3;
        } else if (variantPrice > 6999) {
          installmentsCount = 2; 
        } else if (variantPrice > 0) {
          installmentsCount = 0;
        }

        if (installmentsCount > 1) {
          const installmentValue = formatMoney(variantPrice / installmentsCount);
          const pixValue = formatMoney(variantPrice * 0.95);
          installmentsEl.innerHTML = `
            <b>${installmentsCount}x</b> de <b>${installmentValue}</b>
            sem juros no cartão
            <br>
            ou <b>${pixValue}</b> via Pix
          `;
        } else {
          const pixValue = formatMoney(variantPrice * 0.95);
          installmentsEl.innerHTML = `ou <b>${pixValue}</b> via Pix`;
        }
      }

      if (variantIdInput && variantId) {
        variantIdInput.value = variantId;
      }

      atcButton.disabled = !isAvailable;

      if (quantityInput) {
        quantityInput.disabled = !isAvailable;

        if (!isAvailable) {
          quantityInput.value = "1";
        }
      }

      quantityButtons.forEach((button) => {
        button.disabled = !isAvailable;
      });
    };

    const initGallery = (scope) => {
      const thumbsEl = scope.querySelector(".swipper-thumbs");
      const mainEl = scope.querySelector(".swipper-container");

      if (!mainEl || typeof Swiper === "undefined") return;

      if (thumbsEl) {
        swiperThumbs = new Swiper(thumbsEl, {
          spaceBetween: 10,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesProgress: true,
          breakpoints: {
            992: { direction: "vertical" },
            0: { direction: "horizontal" },
          },
        });
      }

      swiperMain = new Swiper(mainEl, {
        spaceBetween: 10,
        navigation: {
          nextEl: mainEl.querySelector(".swiper-button-next"),
          prevEl: mainEl.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: mainEl.querySelector(".swiper-pagination"),
          type: "fraction",
        },
        thumbs: swiperThumbs ? { swiper: swiperThumbs } : undefined,
      });
    };

    const openFromCard = (card) => {
      const template = card.querySelector(".delucca-quickbuy-template");
      if (!(template instanceof HTMLTemplateElement)) return;

      destroyGallery();
      content.innerHTML = "";

      const fragment = template.content.cloneNode(true);
      content.appendChild(fragment);

      const quickbuyRoot = content.querySelector(".delucca-quickbuy-product");
      if (!quickbuyRoot) return;
      activeQuickbuyProductId = quickbuyRoot.dataset.productId || null;
      quickbuyRoot.dataset.quickbuyVariants = card.dataset.variants || "";

      quickbuyRoot
        .querySelectorAll("script:not([data-quickbuy-variants])")
        .forEach((node) => node.remove());
      initGallery(quickbuyRoot);

      const optionSelects = quickbuyRoot.querySelectorAll("[data-quickbuy-option-select]");
      const optionInputs = quickbuyRoot.querySelectorAll("[data-quickbuy-option-input]");
      if (optionSelects.length) {
        updatePriceAndAvailability(quickbuyRoot);

        optionSelects.forEach((select) => {
          select.addEventListener("change", () => updatePriceAndAvailability(quickbuyRoot));
        });
      } else if (optionInputs.length) {
        updatePriceAndAvailability(quickbuyRoot);

        optionInputs.forEach((input) => {
          input.addEventListener("change", () => updatePriceAndAvailability(quickbuyRoot));
        });
      } else {
        updatePriceAndAvailability(quickbuyRoot);
      }

      modal.showModal();
    };

    document.addEventListener("cart:update", (event) => {
      if (!modal.open || !activeQuickbuyProductId) return;

      const source = event?.detail?.data?.source;
      const productId = String(event?.detail?.data?.productId || "");

      if (source === "product-form-component" && productId === String(activeQuickbuyProductId)) {
        closeModal();
      }
    });

    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-quickbuy-open]");

      if (trigger) {
        event.preventDefault();
        event.stopPropagation();

        const card = trigger.closest(".delucca__product-card");
        if (card) {
          openFromCard(card);
        }

        return;
      }

      if (event.target.closest("[data-quickbuy-close]")) {
        closeModal();
      }
    });

    document.addEventListener("keydown", (event) => {
      const trigger = event.target.closest("[data-quickbuy-open]");
      if (!trigger) return;

      if (event.key !== "Enter" && event.key !== " ") return;

      event.preventDefault();

      const card = trigger.closest(".delucca__product-card");
      if (card) {
        openFromCard(card);
      }
    });

    modal.addEventListener("click", (event) => {
      const rect = modal.getBoundingClientRect();
      const isInDialog =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;

      if (!isInDialog) {
        closeModal();
      }
    });

    closeButton?.addEventListener("click", closeModal);
  }

  /**
   * Inicialização no carregamento inicial da página
   */
  function onDomReady() {
    initVariantSwipers(document);
    initQuickbuyModal();
  }

  /**
   * Shopify Sections (renderizadas via AJAX)
   */
  function onShopifySectionLoad(event) {
    if (!event || !event.target) return;
    initVariantSwipers(event.target);
    initQuickbuyModal();
  }

  /**
   * Observer para produtos carregados dinamicamente (infinite scroll / AJAX)
   */
  function observeDynamicProducts() {
    const productContainer =
      document.querySelector("[data-product-grid]") ||
      document.querySelector("#ProductGridContainer") ||
      document.querySelector(".product-grid");

    const target = productContainer || document.body;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;

          // Se o próprio node for um card
          if (node.matches && node.matches(".delucca__product-card")) {
            initVariantSwipers(node);
            return;
          }

          // Se o node contiver cards
          if (node.querySelectorAll) {
            const cards = node.querySelectorAll(".delucca__product-card");
            if (cards.length) {
              cards.forEach((card) => initVariantSwipers(card));
            }
          }
        });
      });
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
    });
  }

  /**
   * Bind de eventos globais
   */
  document.addEventListener("DOMContentLoaded", onDomReady);
  document.addEventListener("shopify:section:load", onShopifySectionLoad);

  /**
   * Start observer
   */
  observeDynamicProducts();
})();

function scrollToId(id) {
  const element = document.getElementById(id);
  if (!element) return;

  const isDesktop = window.innerWidth >= 992;
  const offset = isDesktop ? 163 : 108;

  const elementPosition = element.getBoundingClientRect().top + window.scrollY;
  const offsetPosition = elementPosition - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
}